// Core
import React from 'react'

// Library
import clsx from 'clsx'

// Styles
import classes from 'components/Onboarding/FormFields/Input.module.scss'

// Types
type propsType = {
  label?: string;
  suffix?: string
  errorMsg?: string | boolean;
  dataCy?: string;
}

const InputWrapper: React.FC<React.PropsWithChildren<propsType>> = ({
  label,
  suffix,
  errorMsg,
  dataCy,
  children,
}) => (
  <div className={clsx(classes.wrapper)} data-cy={dataCy}>
    <div className={clsx(classes.label)}>
      <span>
        {label}
      </span>
      <span className={clsx(classes.suffix)}>
        {suffix}
      </span>
    </div>
    {children}
    {errorMsg && (
      <div className={clsx(classes.error)}>
        {errorMsg}
      </div>
    )}
  </div>
)

export default InputWrapper
